<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Főoldal</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!--ion-card color="primary">
    <ion-card-header>
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Üdvözöljük a Sulinform felületén!</ion-card-title>
      <ion-card-subtitle>Válasszon a menük közül!</ion-card-subtitle>
    </ion-card-header>
  </ion-card-->

  <!--  NÁLAM LÉVŐ ESZKÖZÖK. Csak akkor jelenik meg, ha tényleg van kint eszköz –
        üres kártyával nem foglalunk helyet a kezdőlapon. -->
  <ion-card *ngIf="eszkozok.length" class="eszkoz-kartya">
    <ion-card-header>
      <ion-card-title>Nálad lévő eszköz</ion-card-title>
      <ion-card-subtitle>Az iskolától kölcsönzött eszközök, és mikorra kell visszahozni.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content style="padding:0 0 8px">
      <ion-list [inset]="true" style="margin:0">
        <ion-item *ngFor="let e of eszkozok" lines="full">
          <ion-icon slot="start" name="laptop-outline" [color]="e.kesik ? 'danger' : 'medium'"></ion-icon>
          <ion-label>
            <div><b>{{ e.sorozatszam }}</b></div>
            <ion-note color="medium" style="font-size:.85rem">
              Kiadva: {{ e.kiadva }}
              <span *ngIf="e.varhato_vissza"> · vissza: {{ e.varhato_vissza }}</span>
              <span *ngIf="!e.varhato_vissza"> · nincs megadva visszahozatal</span>
              <!--  A gondviselő több gyerekét is láthatja: enélkül nem derülne ki,
                    melyikükről van szó. -->
              <span *ngIf="e.atvevo_nev"> · {{ e.atvevo_nev }}</span>
            </ion-note>
            <ion-note color="medium" style="font-size:.85rem;display:block" *ngIf="e.megjegyzes">
              {{ e.megjegyzes }}
            </ion-note>
          </ion-label>
          <ion-chip slot="end" color="danger" outline="true" *ngIf="e.kesik">
            {{ e.keses_nap }} napja késik
          </ion-chip>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <!--  TANTERMEN KÍVÜLI, DIGITÁLIS MUNKAREND – ha az igazgató elrendelte a gyermek (a tanuló)
        osztályára. Csak akkor jelenik meg, ha van mai vagy jövőbeli időszak. -->
  <ion-card *ngIf="digitalisMunkarend.length" class="dm-kartya">
    <ion-card-header>
      <ion-card-title><ion-icon name="laptop-outline"></ion-icon> Digitális munkarend</ion-card-title>
      <ion-card-subtitle>Ezekben a napokban a tanítás online, személyes találkozás nélkül folyik – a tanuló az iskola által megadott módon, online vesz részt az órákon.</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content style="padding:0 0 8px">
      <ion-list [inset]="true" style="margin:0">
        <ion-item *ngFor="let x of digitalisMunkarend" lines="full">
          <ion-icon slot="start" name="calendar-outline" [color]="dmMa(x) ? 'tertiary' : 'medium'"></ion-icon>
          <ion-label class="ion-text-wrap">
            <div><b>{{ x.tol | date:'yyyy.MM.dd' }}<span *ngIf="x.ig !== x.tol"> – {{ x.ig | date:'yyyy.MM.dd' }}</span></b></div>
            <ion-note color="medium" style="font-size:.85rem">
              {{ x.osztaly_nev }} osztály<span *ngIf="x.tanulo_nev && loginMode == 'gondviselo'"> · {{ x.tanulo_nev }}</span>
              <span *ngIf="x.ok"> · {{ x.ok }}</span>
            </ion-note>
          </ion-label>
          <ion-chip slot="end" color="tertiary" outline="true" *ngIf="dmMa(x)">ma</ion-chip>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <!--  TANULÓI ÓRAREND – napra bontva, ahogy a telefonon olvasható.
        A heti rács a képernyő méretéhez képest olvashatatlan volt; a diáknak
        ráadásul nem a hét a kérdés, hanem a mai nap.
        A gondviselő ugyanezt látja a gyermekéről; több gyermeknél választ közülük. -->
  <!-- A gondviselő elrejtheti (lehet, hogy csak a feljegyzések érdeklik); ilyenkor egy
       kapcsoló marad a helyén, amivel visszakapcsolja. -->
  <ion-card *ngIf="isSulinformMode() && loginMode == 'gondviselo' && !orarendLathato && gyerekek.length"
            class="orarend-rejtett">
    <ion-item lines="none">
      <ion-icon slot="start" name="calendar-outline" color="medium"></ion-icon>
      <ion-label>
        Órarend a főoldalon
        <p>Kapcsold be, ha a gyermeked napi órarendjét is itt szeretnéd látni.</p>
      </ion-label>
      <ion-toggle slot="end" [checked]="false" aria-label="Órarend a főoldalon"
                  (ionChange)="orarendLathatoValt($event.detail.checked)"></ion-toggle>
    </ion-item>
  </ion-card>

  <ion-card *ngIf="isSulinformMode() && (loginMode == 'tanulo' || (loginMode == 'gondviselo' && orarendLathato && orarendGyerekek.length))"
            class="orarend-kartya">
    <ion-card-header>
      <div class="orarend-fejlec">
        <ion-button fill="clear" size="small" (click)="orarendHetLep(-1)" title="Előző hét" aria-label="Előző hét">
          <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
        </ion-button>
        <div class="orarend-cim">
          <ion-card-title>Órarend</ion-card-title>
          <ion-card-subtitle>{{ orarendNapCime }}</ion-card-subtitle>
          <!-- Egy gyermeknél csak a neve: így is látszik, kinek az órarendje. -->
          <div class="orarend-gyerek-nev" *ngIf="loginMode == 'gondviselo' && orarendGyerekek.length === 1">
            {{ orarendGyerekCimke(orarendGyerekek[0]) }}
          </div>
        </div>
        <ion-button fill="clear" size="small" (click)="orarendHetLep(1)" title="Következő hét" aria-label="Következő hét">
          <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
        </ion-button>
      </div>
      <ion-segment *ngIf="loginMode == 'gondviselo' && orarendGyerekek.length > 1" class="orarend-gyerek-valaszto"
                   scrollable="true" [value]="orarendOktazon" (ionChange)="orarendGyerekValt($event.detail.value)">
        <ion-segment-button *ngFor="let g of orarendGyerekek" [value]="g.oktazon">
          <ion-label>{{ orarendGyerekCimke(g) }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-card-header>

    <ion-card-content class="orarend-tartalom">
      <div class="nap-sav">
        <button type="button" class="nap" *ngFor="let n of orarendHete"
                [class.kivalasztott]="n.datum === orarendNap"
                [class.ma]="n.ma" [class.hetvege]="n.hetvege"
                (click)="orarendNapValt(n.datum)">
          <span class="nap-nev">{{ n.nev }}</span>
          <span class="nap-szam">{{ n.szam }}</span>
        </button>
      </div>

      <div class="orarend-allapot" *ngIf="orarendToltodik">
        <ion-spinner name="dots"></ion-spinner> Órarend betöltése…
      </div>
      <div class="orarend-allapot hiba" *ngIf="!orarendToltodik && orarendHiba">
        <ion-icon name="alert-circle-outline"></ion-icon> {{ orarendHiba }}
        <ion-button size="small" fill="clear" (click)="orarendHetLep(0)">Újra</ion-button>
      </div>

      <div class="ora-lista" *ngIf="!orarendToltodik && !orarendHiba">
        <div class="ora" *ngFor="let o of orarendNapOrai" [style.--ora-szin]="orarendSzin(o)">
          <div class="ora-bal">
            <span class="ora-szam">{{ o.ora }}.</span>
            <span class="ora-ido" *ngIf="orarendIdoKezdes(o)">
              {{ orarendIdoKezdes(o) }}<br>{{ orarendIdoVege(o) }}
            </span>
          </div>
          <div class="ora-kozep">
            <div class="ora-tantargy">{{ o.tantargy || 'Óra' }}</div>
            <div class="ora-hol" *ngIf="orarendHol(o)">{{ orarendHol(o) }}</div>
            <!-- A tanár által beírt óratéma és házi feladat (a tanulói és a szülői oldalon is). -->
            <div class="ora-tema" *ngIf="o.tema">{{ o.tema }}</div>
            <div class="ora-hazi" *ngIf="o.hazifeladat"><b>Házi:</b> {{ o.hazifeladat }}</div>
          </div>
          <div class="ora-jobb">
            <span class="tanar" *ngIf="o.helyettesito">{{ o.helyettesito }}</span>
            <span class="tanar halvany" *ngIf="!o.helyettesito" [class.elmaradt]="o.elmaradt == 1">{{ o.tarto }}</span>
            <span class="helyettesites" *ngIf="o.helyettesito">helyettesítés</span>
            <span class="helyettesites elmaradt-cimke" *ngIf="!o.helyettesito && o.elmaradt == 1">elmarad</span>
          </div>
        </div>

        <div class="orarend-allapot" *ngIf="!orarendNapOrai.length">
          <ion-icon name="cafe-outline"></ion-icon>
          {{ loginMode == 'gondviselo' ? 'Ezen a napon nincs órája.' : 'Ezen a napon nincs órád.' }}
        </div>
      </div>

      <!-- NEM TANÓRAI CÉLÚ FOGLALKOZÁSOK (korrepetálás, napközi, szakkör): alapból rejtve. Csak a
           gondviselő kapcsolhatja be, és csak ha a gyermeknek van ilyen foglalkozása; a tanuló
           nem kap kapcsolót. A beállítás a gyermekre szól, nem a főoldalra. -->
      <ion-item lines="none" class="nem-tanorai-kapcsolo"
                *ngIf="loginMode == 'gondviselo' && orarendNemTanorai?.van && orarendNemTanorai?.modosithato">
        <ion-label class="ion-text-wrap">
          Nem tanórai foglalkozások
          <p>
            Korrepetálás, napközi, szakkör – alapból rejtve.
            <span *ngIf="!orarendNemTanorai?.lathato && orarendNemTanorai?.rejtett">Ezen a héten {{ orarendNemTanorai?.rejtett }} ilyen óra van elrejtve.</span>
          </p>
        </ion-label>
        <ion-toggle slot="end" [checked]="orarendNemTanorai?.lathato" aria-label="Nem tanórai foglalkozások megjelenítése"
                    (ionChange)="orarendNemTanoraiValt($event.detail.checked)"></ion-toggle>
      </ion-item>

      <div class="orarend-labjegyzet">
        <ion-button size="small" fill="clear" (click)="orarendMa()">Ma</ion-button>
        <ion-button size="small" fill="clear" color="medium" *ngIf="loginMode == 'gondviselo'"
                    (click)="orarendLathatoValt(false)" title="Az órarend elrejtése a főoldalról">
          <ion-icon slot="start" name="eye-off-outline"></ion-icon>Elrejtés
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="loginMode == 'dolgozo' && isSulinformMode()">
    <ion-card-header>
      <ion-card-title>Helyettesítések</ion-card-title>
    </ion-card-header>
    <ion-card-content style="margin:0 !important;padding: 0 !important;">
      <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="feljegyzesek">
        <ion-item [button]="true" detail="false" *ngFor="let f of feljegyzesek" (click)="openFeljegyzes(f)">
          <ion-icon *ngIf="f.db=='helyettesites'" color="primary" slot="start" [name]="f.icon || 'briefcase'"
            size="large"></ion-icon>
          <ion-label>
            <strong *ngIf="!f.tantargy_nev && f.tipus!='Na' && f.db=='feljegyzes'">{{f.tipus}}</strong>
            <strong *ngIf="f.tantargy_nev">{{f.tantargy_nev}}</strong>
            <strong *ngIf="!f.tantargy_nev && f.tipus=='Na'">Feljegyzés</strong><br />
            <ion-note color="" class="ion-text-wrap">
              {{ f.targynap | date:'yyyy. MM. dd.':'UTC' }}
            </ion-note><br />
            <ion-note color="" class="ion-text-wrap">
              {{f.szoveg}}. óra<!--  A helyettesítőnek a HELYSZÍN a kérdés: nem a saját
                   órarendjét járja, tehát tudnia kell, hová menjen. -->
              <span *ngIf="f.db=='helyettesites' && (f.osztaly_nev || f.terem)">
                – {{ f.osztaly_nev || '' }}<span *ngIf="f.osztaly_nev && f.terem"> · </span><b *ngIf="f.terem">{{ f.terem }}</b>
              </span><br>
              <i>{{f.tvez}} {{f.tker}} {{f.db=='ertekeles' && f.tipus !="-" ? "- "+f.tipus : ""}}</i>
            </ion-note>
          </ion-label>
          <div class="metadata-end-wrapper" slot="end">
            <ion-icon color="medium" name="chevron-forward"></ion-icon>
          </div>
        </ion-item>
      </ion-list>
      <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="!feljegyzesekToltodik && !feljegyzesek?.length">
        <ion-item detail="false">
          <ion-label><ion-note>Nincs előtted álló helyettesítés.</ion-note></ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>

  </ion-card>
  <ion-card *ngIf="canViewDailySubstitutions()">
    <ion-card-header>
      <ion-card-title>Napi helyettesítés</ion-card-title>
      <ion-card-subtitle>{{ maiDatum }}</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content style="margin:0 !important;padding: 0 !important;">
      <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="napiHelyettesitesek?.length">
        <ion-item detail="false" *ngFor="let h of napiHelyettesitesek">
          <ion-icon color="primary" slot="start" name="briefcase" size="large"></ion-icon>
          <ion-label>
            <strong>{{ h.tantargy || h.tantargy_rovid || '-' }}</strong><br />
            <ion-note class="ion-text-wrap">
              <!--  „Osztály vagy csoport": a csoportos óra (nyelv, fakt) osztály nélkül áll,
                    ott a csoport neve mondja meg, kikhez megy a helyettesítő. -->
              {{ h.ora }}. óra - {{ h.osztaly_csoport || h.osztaly || h.csoport_nev || '-' }} - {{ h.terem || '-' }}
            </ion-note><br />
            <ion-note class="ion-text-wrap">
              {{ h.tarto || '-' }}
              <span *ngIf="h.helyettesito"> → {{ h.helyettesito }}</span>
              <!-- Az elmaradt óra önálló állapot (orarendv2.elmaradt) – nincs helyettesítő, az óra elmarad.
                   Az okát (pl. táppénz) itt szándékosan nem írjuk ki: ezt az egész tantestület látja. -->
              <b *ngIf="h.elmaradt == 1"> – elmarad</b>
              <span *ngIf="h.elmaradt != 1 && (h.helyettesites_tipus || h.helyettesites_mod)">
                ({{ h.helyettesites_tipus || '-' }}/{{ h.helyettesites_mod || '-' }})
              </span>
            </ion-note>
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="!napiHelyettesitesek?.length">
        <ion-item detail="false">
          <ion-label>
            <strong>Ma nincs kiírt helyettesítés.</strong>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>
  <ion-card *ngIf="loginMode != 'dolgozo'">
    <ion-card-header>
      <ion-card-title>Feljegyzések</ion-card-title>
    </ion-card-header>
    <ion-card-content style="margin:0 !important;padding: 0 !important;">
      <div class="gyerek-szuro" *ngIf="loginMode == 'gondviselo' && gyerekValasztoOpcio?.length">
        <ion-select
          interface="popover"
          label="Gyermek"
          label-placement="stacked"
          fill="outline"
          [(ngModel)]="kivGyerek"
          (ionChange)="onFooldalGyerekValtozas($event.detail.value)">
          <ion-select-option *ngFor="let gyerek of gyerekValasztoOpcio" [value]="gyerek.oktazon">
            {{ gyerek.name }}
          </ion-select-option>
        </ion-select>
      </div>

      <!-- A betöltés a kártyán belül látszik, nem blokkoló ablakban: a főoldal többi
           része akkor is használható, ha a feljegyzések forrása lassú vagy nem elérhető. -->
      <div class="feljegyzes-allapot" *ngIf="feljegyzesekToltodik">
        <ion-spinner name="dots"></ion-spinner>
        <span>Feljegyzések betöltése…</span>
      </div>
      <div class="feljegyzes-allapot hiba" *ngIf="!feljegyzesekToltodik && feljegyzesekHiba">
        <ion-icon name="cloud-offline-outline"></ion-icon>
        <span>{{ feljegyzesekHiba }}</span>
        <ion-button size="small" fill="clear" (click)="loadFeljegyzesek()">Újra</ion-button>
      </div>
      <div class="feljegyzes-allapot"
           *ngIf="!feljegyzesekToltodik && !feljegyzesekHiba && !lathatoFeljegyzesek.length">
        <ion-icon name="document-outline"></ion-icon>
        <span>Nincs megjeleníthető feljegyzés.</span>
      </div>

      <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="feljegyzesek">
        <ion-item [button]="true" detail="false" *ngFor="let f of lathatoFeljegyzesek" (click)="openFeljegyzes(f)">
          <ion-icon *ngIf="f.db=='feljegyzes' || (f.ertekeles || '').length >= 5" color="primary" slot="start"
            [name]="f.icon || 'pencil'" size="large"></ion-icon>
          <ion-icon *ngIf="f.db=='hazi'" color="primary" slot="start" [name]="f.icon || 'home'" size="large"></ion-icon>
          <ion-icon *ngIf="f.db=='tanorai'" [color]="f.tipus == 'Dicséret' ? 'success' : 'warning'" slot="start"
            [name]="f.icon || 'alert-circle-outline'" size="large"></ion-icon>
          <!-- Fegyelmi eljárás értesítése (Nkt. 58. § (3)) – a részlet megnyitva (fegyelmi.js). -->
          <ion-icon *ngIf="f.db=='fegyelmi'" color="danger" slot="start" [name]="f.icon || 'shield-outline'" size="large"></ion-icon>
          <span *ngIf="f.db=='ertekeles' && (f.ertekeles || '').length < 5"
            style="color: var(--ion-color-primary);font-weight: bold;margin-inline-end: 32px;">{{("&emsp;&emsp;&emsp;" +
            (f.ertekeles)).slice(-4)}}</span>

          <ion-label>
            <strong *ngIf="!f.tantargy_nev && f.tipus!='Na' && f.db=='feljegyzes'">{{f.tipus}}</strong>
            <strong *ngIf="f.db=='fegyelmi'">{{f.tipus}}</strong>
            <strong *ngIf="f.tantargy_nev">{{f.tantargy_nev}}</strong>
            <strong *ngIf="!f.tantargy_nev && f.tipus=='Na'">Feljegyzés</strong><br />
            <ion-note color="" class="ion-text-wrap">
              {{ f.targynap | date:'yyyy. MM. dd.':'UTC' }} - {{f.dvez}} {{f.dker}}
            </ion-note><br />
            <ion-note color="" class="ion-text-wrap">
              {{f.szoveg || f.tema || (f.modja == 2 && f.tema==""&&f.tipus=="-" ? "Félévi értékelés" : "-")}}<br>
              <i>{{f.tvez}} {{f.tker}} {{f.db=='ertekeles' && f.tipus !="-" ? "- "+f.tipus : ""}}</i>
            </ion-note>
          </ion-label>
          <div class="metadata-end-wrapper" slot="end">
            <!--  GEMKAPOCS. Enélkül a szülő nem tudta, hogy a házi feladathoz fájl is
                  tartozik: a sor ugyanúgy nézett ki, mint a többi, tehát meg sem
                  nyitotta. A tanár feltöltötte, a szülő nem látta — mindkettő igaz volt. -->
            <span class="melleklet-jel" *ngIf="mellekletDb(f)">
              <ion-icon name="attach-outline"></ion-icon>{{ mellekletDb(f) }}
            </span>
            <ion-icon color="medium" name="chevron-forward"></ion-icon>
          </div>
        </ion-item>
      </ion-list>
      <div class="tovabbi-adatok" *ngIf="vanTovabbiFeljegyzes">
        <ion-button fill="clear" (click)="tovabbiFeljegyzesekBetoltese()">
          További adatok betöltése
        </ion-button>
      </div>
    </ion-card-content>

  </ion-card>
  <ion-modal class="" style="z-index: 1000" #feljegyzesmodal>
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="close()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Feljegyzés</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto">
        {{f.tantargy_nev}} - {{ f.targynap | date:'yyyy. MM. dd.':'UTC' }} - {{f.dvez}} {{f.dker}}<br>
        <!-- A mezős feljegyzés (pl. mobilhasználati engedély) szövege soronként tagolt. -->
        <span style="white-space:pre-line">{{f.reszlet || f.szoveg || f.tema || f.ertekeles || "-"}}</span><br>
        <i>{{f.tvez}} {{f.tker}} {{f.db=='ertekeles' && f.tipus !="-" ? "- "+f.tipus : ""}}</i>

        <div class="fajl-hiba" *ngIf="fajlokHiba">
          <ion-icon name="cloud-offline-outline"></ion-icon> {{ fajlokHiba }}
        </div>

        <!--  A HÁZI FELADAT MELLÉKLETE JELLEMZŐEN FÉNYKÉP: a tábláról vagy a
              munkafüzetből. Ezt helyben megmutatjuk — egy fájlnév önmagában nem
              mond semmit, és a szülő nem fog rákattintani, hogy megtudja. -->
        <div class="hazi-kepek" *ngIf="fajlok?.length">
          <img *ngFor="let file of fajlok" [hidden]="!kepE(file)" [src]="fajlUrl(file.Key)"
               [alt]="file.name" loading="lazy" (click)="openLink(file.Key)" />
        </div>

        <div class="files-list" *ngIf="fajlok && fajlok.length != 0">
          Feltöltött fájlok:
          <div class="single-file" *ngFor="let file of fajlok; let i = index">
            <div class="file-icon" style="width: 50px" (click)="openLink(file.Key)">
              <img *ngIf="file?.name.slice(-3) == 'xls' ||file?.name.slice(-4) == 'xlsx'"
                src="assets/svg/excel-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'pdf'" src="assets/svg/pdf-document-svgrepo-com.svg">
              <img
                *ngIf="file?.name.slice(-4) == 'webp' ||file?.name.slice(-3) == 'svg' ||file?.name.slice(-3) == 'jpg' ||file?.name.slice(-3) == 'png' ||file?.name.slice(-4) == 'jpeg'"
                src="assets/svg/image-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'mp3' ||file?.name.slice(-3) == 'mp4'"
                src="assets/svg/video-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'zip'" src="assets/svg/zip-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'txt'" src="assets/svg/txt-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'ppt' ||file?.name.slice(-4) == 'pptx'"
                src="assets/svg/ppt-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'doc' ||file?.name.slice(-4) == 'docx'"
                src="assets/svg/word-document-svgrepo-com.svg">
            </div>
            <div class="info" (click)="openLink(file.Key)">
              <h4 class="name">
                {{ file?.name }}
              </h4>
            </div>
          </div>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
